<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :deaprtFlag="false" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" :confKey="confKey" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :configAuto="true" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row" v-if="checkActionPerm('create')">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="addClearStuff(false)">
                    <span>新增清除单</span>
                </button>
                <button class="swb-btn swb-btn-small" v-if="checkActionPerm('register')" @click="addClearStuff(true)">
                    <span>登记清除单</span>
                </button>
            </div>
        </div>
        <div name="tabs-block">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="全部" name="all"></el-tab-pane>
                <el-tab-pane name="applyInitial">
                    <span slot="label">未申请<i class="num-marker">{{ initialCount }}</i></span>
                </el-tab-pane>
                <el-tab-pane label="已申请" name="applyApplied"></el-tab-pane>
                <el-tab-pane name="applyHandled">
                    <span slot="label">已审核<!--<i class="num-marker">{{auditFailCount}}</i>--></span>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div class="mt5">
            <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect"
                              :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth"
                              :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
        </div>
    </div>
</template>
<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes} from '../../app.vues'
    import appConf from '../../app.conf';
    import assetVchrApi from '../../api/assetVchr'
    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'
    import {checkUserActionPerm} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import {showComActionPostSelectDlg} from '../merchant/showSelectDlg'
    import {getMerchtAuditBpConfInfo, openDingdingAuditViewDlg, openAuditTypeDlg} from '../oaAudit/selectDlg'

    import SwbShopDeviceClearVoucherSave from './ShopDeviceClearVoucherSave.vue'

    Routes.add(SwbShopDeviceClearVoucherSave);

    import SwbShopDeviceClearVoucherShow from './ShopDeviceClearVoucherShow'

    Vue.regist(SwbShopDeviceClearVoucherShow);

    import SwbShopDeviceClearVoucherAuditList from './ShopDeviceClearVoucherAuditList'

    Routes.add(SwbShopDeviceClearVoucherAuditList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //
    export default {
        name: 'swb-clear-device-io-voucher-list',
        desc: '清除资产列表',
        path: '/shop/device/clear/voucher/apply/list',
        avlActions: 'create|view_detail|modify|apply|delete|view_rec',
        avlActionNames: '查看详情',
        avlScopes: 'retailer',
        data: function () {
            return {
                confKey: 'swb-clear-device-io-voucher-apply-list',
                tableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 250,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                voucherTypeMap: [],
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                activeName: 'all',
                no: null,
                innerNo: null,
                initialCount: 0,
                appliedCount: 0,
                auditFailCount: 0,
                //
                comLevel: null,
                bizUnitId: null,
                selectComId: null,
                includeSubComs: null,
                //
                dingDingAuditFlag: false,
                devcVoucherTypeMap: getEnumMap('devcVoucherType', 'value2text')
            }
        },
        created: function () {
            this.voucherTypeMap = getEnumMap('devcVoucherType', 'value2text');
            //
            let innerNo = this.$route.query.innerNo || null;
            if (!Utils.isNoB(innerNo)) {
                this.queryModel.filterItems.innerNo = innerNo;
                this.innerNo = innerNo;
            }
            let no = this.$route.query.no || null;
            if (!Utils.isNoB(no)) {
                this.queryModel.filterItems.no = no;
                this.no = no;
            } else {
                this.getCurrentUserInfo();
            }
            //
            let self = this;
            getMerchtAuditBpConfInfo('retailer.assets.clear', false, function (auditBpConfInfo) {
                self.dingDingAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 2 && auditBpConfInfo.ready);
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-area"],.simple-row,[name="tabs-block"],.org-tree-layout'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            // 获取用户当前信息
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        self.merchantId = data.scopeEntity.id;
                        self.comLevel = data.scopeEntity.comLevel;
                        self.selectComId = data.scopeEntity.comId;
                        self.bizUnitId = data.scopeEntity.bizUnitId;
                        self.bizUnitName = data.scopeEntity.bizUnitName;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            checkComCatChange: function (eventData) {
                this.comLevel = eventData.level;
                this.selectComId = eventData.id;
                this.bizUnitId = eventData.bizUnitId;
                this.bizUnitName = eventData.bizUnitName;
                this.includeSubComs = eventData.includeSubComs;
                this.getClearVoucherList();
            },
            onConfigReady: function () {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let no = this.no;
                if (!Utils.isNoB(no)) {
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo['no'] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
                let innerNo = this.innerNo;
                if (!Utils.isNoB(innerNo)) {
                    let data = {value: innerNo};
                    let fieldInfo = {};
                    fieldInfo['innerNo'] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.srcVoucherType != null) {
                            return '<span class="swb-tags swb-tags-danger">' + self.voucherTypeMap[row.srcVoucherType] + '</span>' + '<span >' + colValue + '</span>';
                        } else {
                            return '<span >' + colValue + '</span>';
                        }
                    },
                    'unbind': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span >是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'createOutVoucher': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.createOutVoucher) {
                            return '<span class="font-green">已生成</span>';
                        } else {
                            return '<span class="font-red">未生成</span>';
                        }
                    },
                    'auditState': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.applyState == 0) {
                            return '<span>未申请</span>';
                        } else if (row.applyState == 1) {
                            return '<span>已申请</span>';
                        } else if (row.applyState == 2) {
                            if (colValue === 1) {
                                return '<span class="font-green">审核已通过</span>';
                            } else if (colValue === -1) {
                                return '<span class="font-red">审核未通过</span>';
                            }
                        }
                    },
                    'srcVoucherType': function (row, colName, colValue, rowIndex) {
                        if (!Utils.isNoB(row.srcVoucherType)) {
                            return '<span>' + self.devcVoucherTypeMap[row.srcVoucherType] + '</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.checkActionPerm('view_detail', null, row.comId)) {
                            btnList.push({
                                name: 'view_detail',
                                text: '查看详情'
                            });
                        }
                        if (self.checkActionPerm('modify', null, row.comId) && row.applyState != 1 && row.auditState != 1) {
                            btnList.push({
                                name: 'modify',
                                text: '修改'
                            });
                        }
                        if (self.checkActionPerm('apply', null, row.comId) && row.applyState != 1 && row.auditState != 1) {
                            btnList.push({
                                name: 'apply',
                                text: '申请'
                            });
                        }
                        if (self.checkActionPerm('delete', null, row.comId) && ((row.auditState == -1 && row.applyState != 1) || row.applyState == 0)) {
                            btnList.push({
                                name: 'delete',
                                text: '删除'
                            });
                        }
                        if (self.checkActionPerm('view_rec', null, row.comId)) {
                            btnList.push({
                                name: 'view_rec',
                                text: '操作记录'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                            return;
                        }
                        if (btnName == 'view_detail') {
                            self.viewCearVoucher(row.id);
                        } else if (btnName == 'modify') {
                            self.editorClearVoucher(row.id);
                        } else if (btnName == 'view_rec') {
                            self.showActRec(row.no);
                        } else if (btnName == 'apply') {
                            self.applyClearVoucher(row);
                        } else if (btnName == 'delete') {
                            self.doDeleteClearVoucher(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log('----- 双击数据行 ----');
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            // 操作权限控制
            checkActionPerm: function (action, targetPostId, dataOwnerComId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                this.pageNumber = 1;
                this.getClearVoucherList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getClearVoucherList();
            },

            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getClearVoucherList();
            },
            handleClick() {
                this.handlePageChange(1);
            },
            getClearVoucherList: function () {
                let self = this;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.tabCheckFlag = self.activeName;
                let state = filterItems.state;
                if (!Utils.isNoB(state)) {
                    if (state == 4) {
                        filterItems.applyState = 0;
                    } else if (state == 0) {
                        filterItems.applyState = 1;
                        filterItems.auditState = 0;
                    } else {
                        filterItems.auditState = state;
                    }
                }
                filterItems.comLevel = self.comLevel;
                filterItems.bizUnitId = self.bizUnitId;
                filterItems.includeSubComs = self.includeSubComs;
                filterItems.retailerComId = self.selectComId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceClearVoucherList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(result.data.rows, pagination);
                        self.getApplyStateInitialTodoCount();
//                        self.getAuditStateAuditFailTodoCount();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getApplyStateInitialTodoCount: function () {
                let self = this;
                let postData = {
                    assetType: -1,
                    comId: self.selectComId,
                    comLevel: self.comLevel,
                    includeSubComs: self.includeSubComs,
                    bizUnitId: self.bizUnitId,
                    tabCheckFlag: 'applyInitial'
                };
                assetVchrApi.getShopDeviceClearVoucherApplyStateInitialTodoCount(postData, function (result) {
                    if (result.type == 'info') {
                        self.initialCount = result.data;
                    }
                })
            },
            getAuditStateAuditFailTodoCount: function () {
                let self = this;
                let postData = {
                    assetType: -1,
                    comId: self.selectComId,
                    comLevel: self.comLevel,
                    includeSubComs: self.includeSubComs,
                    bizUnitId: self.bizUnitId,
                    tabCheckFlag: 'auditFail'
                };
                assetVchrApi.getShopDeviceClearVoucherAuditStateAuditFailTodoCount(postData, function (result) {
                    if (result.type == 'info') {
                        self.auditFailCount = result.data;
                    }
                })
            },
            addClearStuff: function (autoApplyAndAudit) {
                if (!Utils.repeatChecker.isValidFor('addClearStuff', 1000)) {
                    return;
                }
                let self = this;
                this.$router.push({
                    path: SwbShopDeviceClearVoucherSave.path,
                    query: {
                        autoApplyAndAudit: autoApplyAndAudit,
                        parentPath: self.$route.path,
                        bizUnitId: self.bizUnitId,
                        bizUnitName: self.bizUnitName,
                        comId: self.selectComId,
                    }
                });
            },
            editorClearVoucher: function (id) {
                let title = id != null ? '清除单-编辑' : '清除单-新增';
                this.$router.push({
                    path: SwbShopDeviceClearVoucherSave.path,
                    query: {
                        id: id,
                        parentPath: this.$route.path
                    }
                });
            },
            viewCearVoucher: function (id) {
                Vue.$showDialog({
                    title: '资产清除-详情',
                    width: 1500,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<swb-shop-device-clear-voucher :id="id"></swb-shop-device-clear-voucher>',
                    data: {
                        id: id,
                    }
                });
            },

            applyClearVoucher: function (row) {
                let self = this;
                if (Utils.isTrue(self.dingDingAuditFlag)) {
                    openAuditTypeDlg(null, function (auditType, theDlg) {
                        theDlg.close();
                        let dingDingFlag = Utils.isTrue(auditType);
                        if (dingDingFlag) {
                            row.dingDingFlag = dingDingFlag;
                            self.toDingDingBpAudit(row);
                        } else {
                            // 申请内部审批
                            self.toInnerApplyClearVoucher(row);
                        }
                    });
                } else {
                    // 申请内部审批
                    self.toInnerApplyClearVoucher(row);
                }
            },
            // 钉钉申请
            toDingDingBpAudit: function (row) {
                let self = this;
                //
                let params = {
                    bizVoucherId: row.id,
                    bizVoucherNo: row.no,
                    bizTypeCode: 'retailer.assets.clear',
                };
                openDingdingAuditViewDlg(params, function (resultData) {
                    let departId = resultData.departId;
                    // 返回值：departId（部门ID）
                    let postData = {
                        id: row.id,
                        no: row.no,
                        //
                        departId: departId || null,
                        dingdingFlag: row.dingDingFlag
                    };
                    let theLoad = MsgBox.loading();
                    assetVchrApi.applyShopDeviceClearVoucher(postData, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            MsgBox.success('申请成功！');
                            self.getClearVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 内部申请
            toInnerApplyClearVoucher: function (row) {
                let self = this;
                showComActionPostSelectDlg({
                    title: '清除单申请 - 指定审核岗',
                    rescUrl: SwbShopDeviceClearVoucherAuditList.path,
                    action: 'audit',
                    useParents: true,
                    initPostId: row.auditorPostId,
                    applyDesc: row.applyDesc
                }, function (resultData) {
                    resultData = resultData || {};
                    if (resultData.postId == null) {
                        Toast.show('请选择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: row.id,
                        auditorPostId: resultData.postId,
                        auditorPostName: resultData.postName,
                        auditComId: resultData.comId,
                        auditComName: resultData.comName,
                        auditComLevel: resultData.comLevel,
                        applyDesc: resultData.applyDesc,
                        autoAuditPass: false,
                    };
                    //
                    let theLoad = MsgBox.loading();
                    assetVchrApi.applyShopDeviceClearVoucher(postData, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            MsgBox.success('申请成功！');
                            self.getClearVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },
            // 删除清除单
            doDeleteClearVoucher: function (id) {
                let self = this;
                self.$confirm('确定要删除该信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    assetVchrApi.deleteShopDeviceClearVoucher(postData, function (result) {
                        theLoad.hide();
                        if (result.type === 'info') {
                            self.getClearVoucherList();
                            MsgBox.success('删除成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 清除单操作记录
            showActRec(no) {
                Vue.$showDialog({
                    title: '清除单操作记录 - 查看',
                    width: 1200,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<div>' +
                        '<swb-shop-device-act-rec-list :showComFlag="false" :srcVoucherNo="srcVoucherNo" :srcVoucherType="srcVoucherType" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>' +
                        '</div>',
                    data: {
                        srcVoucherNo: no,
                        srcVoucherType: getEnumInfoWith('devcVoucherType', 'name', 'Clear').value
                    }
                });
            },
            doUnBuild(id) {
                let self = this;
                self.$confirm('确定要解绑此单据信息吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    assetVchrApi.updateShopDeviceClearVoucherUnBnbind(postData, function (result) {
                        theLoad.hide();
                        if (result.type === 'info') {
                            self.getClearVoucherList();
                            MsgBox.success('删除成功!');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/clearVoucher/ShopDeviceClearVoucherApplyList.vue